import checkSubmissionForErrors from "~/store/manage/validation/checkSubmissionForErrors";

const VALIDATE_SUBMISSION = (state, featureToggles) => {
  state.submissionErrors = checkSubmissionForErrors(state, featureToggles);
};

export default VALIDATE_SUBMISSION;
